import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import SvgError from '../../../../assets/svgs/error.svg';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

class Textarea extends PureComponent {
  render() {
    const {
      value = '',
      disabled,
      fullWidth,
      className,
      innerRef,
      errorText,
      maxLength,
      onChange,
      ...props
    } = this.props;

    return (
      <>
        <textarea
          value={value}
          className={cx('Textarea', { disabled, fullWidth, errorText }, className)}
          disabled={disabled}
          onChange={
            value.length <= maxLength
              ? onChange
              : onChange({ target: { value: value.slice(0, maxLength) } })
          }
          {...props}
          ref={innerRef}
        />
        <div className={cx('options')}>
          {errorText && (
            <div className={cx('error-text')}>
              <SvgError />
              {errorText}
            </div>
          )}
          {maxLength && (
            <>
              <div></div>
              <div className={cx('max-length')}>
                {value.length || 0}/{maxLength}
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

Textarea.propTypes = {
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default React.forwardRef((props, ref) => <Textarea innerRef={ref} {...props} />);
